module.exports = __webpack_public_path__ + "fonts/MicrobrewThree.43002ba1d1785315f18c3c7221c793a4.woff";